export default __webpack_public_path__ + "static/media/Keyboard.a4312963.svg";